namespace Serenity {

    // legacy, don't use!
    @Decorators.registerInterface('Serenity.IAsyncInit')
    export class IAsyncInit {
    }

}